import { ReportsApi } from '../../../api/reportSettingsApi';
import { SnackbarData } from '../../../interfaces/Snackbar';
import withSnackbar from '../../../shared/components/withSnackbar';
import {
	SovosButton,
	SovosLinearProgress,
	SovosMenuItem,
	SovosPageLayout,
	SovosSelect,
	SovosTextField,
} from 'mosaic-react';
import React, { useState } from 'react';

const ReportSettingsPage: React.FC<SnackbarData> = ({ showSnackbar }: SnackbarData) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [processId, setProcessId] = useState<string>('');
	const [reportType, setReportType] = useState<string>('');

	const handleResetButton = async () => {
		setIsLoading(true);
		await ReportsApi.resetParams(processId, reportType)
			.then(response => {
				if (response.status === 200) {
					showSnackbar({ message: 'Report was successfully reset', variant: 'confirmation' });
				}
			})
			.catch(error =>
				showSnackbar({ message: error.response.data.message || error.response.statusText, variant: 'error' })
			)
			.finally(() => setIsLoading(false));
	};

	const handleGenerateReport = async () => {
		setIsLoading(true);
		showSnackbar({
			message: 'Your report is being generated. Please do not leave or refresh the page.',
			variant: 'confirmation',
		});
		await ReportsApi.getGenerateReportsParams(processId, reportType)
			.catch(error =>
				showSnackbar({ message: error.response.data.message || error.response.statusText, variant: 'error' })
			)
			.finally(() => setIsLoading(false));
	};

	return (
		<SovosPageLayout pageTitle='Report Settings'>
			{isLoading && <SovosLinearProgress variant='indeterminate' />}
			<div
				style={{
					filter: isLoading ? 'blur(3px)' : '',
					width: '30%',
					paddingLeft: 20,
					display: 'flex',
					flexDirection: 'column',
					marginTop: 10,
				}}
			>
				<SovosTextField
					name='processId'
					label='Process ID'
					value={processId}
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						setProcessId(event.target.value);
					}}
					required
					variant='outlined'
				/>
				<SovosSelect
					id='reportType'
					value={reportType}
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						setReportType(event.target.value);
					}}
					label='Report Type'
					variant='outlined'
				>
					<SovosMenuItem value={'error'}>Calculation Error</SovosMenuItem>
					<SovosMenuItem value={'validation'}>Configuration Error</SovosMenuItem>
					<SovosMenuItem value={'export'}>Export</SovosMenuItem>
					<SovosMenuItem value={'summary'}>Summary</SovosMenuItem>
				</SovosSelect>
				<div style={{ filter: isLoading ? 'blur(3px)' : '', display: 'flex', justifyContent: 'end' }}>
					<SovosButton
						variant='text'
						style={{ marginTop: 16, marginLeft: 10 }}
						onClick={handleResetButton}
						disabled={processId === '' || reportType === ''}
					>
						Reset
					</SovosButton>
					<SovosButton
						variant='contained'
						style={{ marginTop: 16, marginLeft: 10 }}
						onClick={handleGenerateReport}
						disabled={processId === '' || reportType === ''}
					>
						Generate
					</SovosButton>
				</div>
			</div>
		</SovosPageLayout>
	);
};

export default withSnackbar(ReportSettingsPage);
